import axios from 'axios';

import { HTTP_HEADER } from '@/api/util/httpHeaders.model.ts';
import { getCsrfToken } from '@/api/util/useAxiosInstance.util.tsx';
import CONFIG from '@/config/config.ts';

export const logout = async (): Promise<void> => {
  const csrfToken = await getCsrfToken();
  const logoutResponse = await axios.post(`${CONFIG.HOST}/api/v1/logout`, null, {
    headers: {
      [HTTP_HEADER['X-CSRF-TOKEN']]: csrfToken,
    },
  });
  const logoutForwardUrl = logoutResponse.headers.location;

  window.location.href = logoutForwardUrl;
};
